module.exports = __webpack_public_path__ + "static/img/how-it-work-4.7f7dfa08.svg";